// export const info = (data) => {
//     return data;
// };

export default {
};
